import { formatISODate } from "@clipboard-health/date-time";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { PACIFIC_TIME_ZONE } from "@src/appV2/Timezone/constants";
import { addHours } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { zonedTimeToUtc } from "date-fns-tz";

/** Midday, so a date can't slip a day when converted across time zones. */
const DEADLINE_HOUR = 12;

export function useFormatTimestampForWorkplace() {
  const session = useSession();
  const sessionTimezone = session.profile?.tmz ?? PACIFIC_TIME_ZONE;
  return (timestamp: Date) => zonedTimeToUtc(timestamp, sessionTimezone).toISOString();
}

/**
 * Reverse of {@link useFormatTimestampForWorkplace}: converts a stored ISO
 * timestamp into a `yyyy-MM-dd` string in the workplace timezone, suitable for
 * pre-filling a native `<input type="date">`.
 */
export function useFormatWorkplaceDateInput() {
  const session = useSession();
  const sessionTimezone = session.profile?.tmz ?? PACIFIC_TIME_ZONE;
  return (timestamp: string) => formatISODate(timestamp, { timeZone: sessionTimezone });
}

/**
 * Turns the `yyyy-MM-dd` a date input holds into the ISO timestamp a visit
 * deadline is stored as.
 */
export function useParseDateFieldToISO() {
  const formatTimestampForWorkplace = useFormatTimestampForWorkplace();

  return (dateString: string) => {
    const [yearStr, monthStr, dayStr] = dateString.split("-");
    const localDate = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr));
    return formatTimestampForWorkplace(addHours(localDate, DEADLINE_HOUR));
  };
}
